export const EARTH_RADIUS = 6378100.0

export const UNITS = {
  METERS    : 'METERS',
  KILOMETERS: 'KILOMETERS',
  MILES     : 'MILES',
  YARDS     : 'YARDS',
  FEET      : 'FEET'
}



// WEBPACK FOOTER //
// ./src/geo/constants.js